import React, { useEffect, useState } from 'react';
import { notification } from '../../hocs/notification';

import axios from 'axios';
import { mainurl } from '../../../Mainurl';

import { FaHeading } from 'react-icons/fa';
import { Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Input, Label, InputGroup, InputGroupText, Spinner, Button } from 'reactstrap';

const AddCrop = ({ back }) => {
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');
    const [type, setType] = useState('');
    const [cropTypeOpt, setCropTypeOpt] = useState('');

    //

    useEffect(() => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_type_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.crop_type_id}> {row.crop_type_name}</option>
                    )
                });

                setCropTypeOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }, [])


    const add_handler = (e) => {
        e.preventDefault();


        let postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "crop_name": name,
            "crop_type_id": type,

        }];

        console.log(postData);
        axios({
            method: 'post',
            url: mainurl + 'Common/crop_add',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                if (response.data[0].retcode === 101) {
                    let notify = notification({ message: "Crop added Successfully.", type: 'info', time: true, position: 'center' });
                    notify();
                    back();
                }
            })
            .catch(error => {
                let notify = notification({ message: "Submit failed! Try Again", type: 'error', time: true });
                notify();
            });
    }

    return (
        <>
            <Card className='mb-3' color="primary" outline>
                <CardHeader> Add New Crop </CardHeader>
                <CardBody>
                    <Form onSubmit={add_handler}>

                        <FormGroup row>
                            <Label for="state" sm={2} > Crop Type </Label>
                            <Col sm={4}>
                                <Input id="state" bsSize="sm" type="select" value={type} onChange={(e) => setType(e.target.value)} required>
                                    <option value="0"> --Select State--</option>
                                    {cropTypeOpt}
                                </Input>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="name" sm={2} > Crop Name </Label>
                            <Col sm={4}>
                                <Input id="name" type='text' bsSize="sm" value={name} onChange={(e) => setName(e.target.value)} required />
                            </Col>
                        </FormGroup>

                        <Row>
                            <hr />
                            <Col md={2} className="mb-2">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </CardBody>
            </Card>
            <div className='text-end'>
                <Button className='text-white' color='primary' size="sm" onClick={back}> Back </Button>
            </div>
        </>
    )
}

export default AddCrop;